import script from "./TextComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextComponent.vue?vue&type=script&lang=ts&setup=true"

import "./TextComponent.vue?vue&type=style&index=0&id=b2c97340&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2c97340"]])

export default __exports__